uniform vec2 uResolution;
uniform float uSize;

uniform vec3 uColorA;
uniform vec3 uColorB;

#include ../includes/simplexNoise3d.glsl

varying vec3 vColor;

void main()
{
    // Generate noise based on the original position
    float noise = simplexNoise3d(position * 0.3);
    noise = smoothstep(-1.0, 1.0, noise); // Normalize noise to 0-1

    // Mix colors based on noise
    vColor = mix(uColorA, uColorB, noise * 1.2);

    // Final position
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    // Point size
    gl_PointSize = uSize * uResolution.y;
    gl_PointSize *= (1.0 / -viewPosition.z);
}
